<template>
    <div>
        <PriceSpecificationTransfer :product="product" />
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { TransferProduct } from '@/api/Cart/cart.interfaces';
    import PriceSpecificationTransfer from '@/components/shared/PriceSpecification/Transfer/PriceSpecificationTransfer.vue';

    export default defineComponent({
        name: 'TransferModalPrice',
        components: { PriceSpecificationTransfer },
        props: {
            product: {
                type: Object as PropType<TransferProduct>,
                required: true,
            },
        },
    });
</script>
